/* global aqHomeConfig */

import Typed from 'typed.js';
import objectFitImages from 'object-fit-images';
import ImageBuddy from 'imagebuddy';

import UASniffer from './util/ua-sniffer';
import GravPopups from './util/grav-popups';
import gravUtil from './util/grav-util';
import SiteEvents from './util/site-events';

import Modal from './components/modal';
import Accordion from './components/accordion';
import TabbedContent from './components/tabbed-content';
import BannerVideo from './components/banner-video';

import TripLogsArchiveTemplate from './templates/trip-logs-archive';
import TripLogSessionArchiveTemplate from './templates/trip-log-session-archive';

import BlockSlider from './blocks/slider';
import BlockTestimonials from './blocks/testimonials';
import BlockTimelineSlider from './blocks/timeline-slider';
import BlockTimelineContent from './blocks/timeline-content';
import BlockTimelineHero from './blocks/timeline-hero';
import BlockTimelineTripLogs from './blocks/timeline-trip-logs';
import BlockInstagram from './blocks/instagram';

/**
 * Global instance variables
 */
const instances = {
	blocks: {
		slider: [],
		testimonials: [],
		timelineSlider: [],
		timelineContent: [],
		timelineTripLogs: [],
		timelineHero: [],
		instagram: []
	},
	components: {
		accordion: [],
		tabbedContent: [],
		bannerVideo: false
	},
	templates: {
		adventuresArchive: null,
		blogArchive: null,
		tripLogsArchive: null,
		tripLogSessionArchive: null
	},
	gravPopups: null
};

function addBrowserAndOSClasses() {
	const uaSniffer = new UASniffer();
	const browserClasses = uaSniffer.getBrowserClasses();
	const osClasses = uaSniffer.getOSClasses();
	const htmlEl = document.querySelector('html');

	browserClasses.forEach((className) => {
		htmlEl.classList.add(className);
	});

	osClasses.forEach((className) => {
		htmlEl.classList.add(className);
	});
}

jQuery(function ($) {
	/**
	 * Global variables
	 */
	let headerHeight = 0;

	/**
	 * Custom jQuery extensions
	 */
	$.fn.scrollIntoView = function (speed, padding) {
		return this.each(function () {
			$('html, body').animate(
				{
					scrollTop: $(this).offset().top - padding
				},
				speed
			);
		});
	};

	$.fn.scrollToAnchor = function () {
		return this.on('click tap', function (e) {
			const anchorId = $(this).attr('href');
			const $anchor = $(anchorId);

			e.preventDefault();

			if (!$anchor.length) {
				return;
			}

			if ($anchor.parents('.ui__accordion-container').length) {
				$anchor.trigger('open-accordion-item');
			}

			$anchor.scrollIntoView(1000, 20);
		});
	};

	$.fn.inViewport = function () {
		const win = $(window);
		const scrollPosition = win.scrollTop();
		const visibleArea = win.scrollTop() + win.height();
		const objEndPos = $(this).offset().top + win.height();

		return visibleArea >= objEndPos && scrollPosition <= objEndPos;
	};

	/**
	 * DOM ready
	 */
	$(document).ready(function () {
		addBrowserAndOSClasses();

		headerHeight = $('.site-header').height();

		gravUtil.filterLinks();
		gravUtil.setHeightVars();
		gravUtil.setScrollVars();
		gravUtil.updateScrollClasses(headerHeight);

		/**
		 * Initialize Typed for the home banner if needed
		 */
		if ($('.banner--home__typed-output').length && $('.banner--home__typed-hidden p').length) {
			let typedSpeed = 75;
			let typedPause = 2000;
			let typedLoop = false;

			try {
				typedSpeed = aqHomeConfig.typed.speed;
				typedPause = aqHomeConfig.typed.pause;
				typedLoop = aqHomeConfig.typed.loop;
			} catch (e) {
				// ReferenceError safety net in case aqHomeConfig does not exist
			}

			const typed = new Typed('.banner--home__typed-output', {
				stringsElement: '.banner--home__typed-hidden',
				typeSpeed: typedSpeed,
				backSpeed: typedSpeed,
				backDelay: typedPause,
				cursorChar: '',
				loop: typedLoop
			});
		}

		/**
		 * Mobile nav toggle handler
		 */
		$('.site-header__hamburger').on('click tap', function (e) {
			e.preventDefault();

			$('html').toggleClass('mobile-nav-open');
		});

		/**
		 * ImageBuddy
		 * used to select the best image for a container by using the
		 * data-ib-sources attribute
		 */
		window.imageBuddy = new ImageBuddy({
			lazyLoad: true,
			lazyLoadThreshold: 300
			// debug: true
		});

		ImageBuddy.on('image-loaded', (imgEl) => {
			objectFitImages(imgEl);
		});

		$(window).on(SiteEvents.IMAGEBUDDY_TRIGGER_UPDATE, function (e, opts) {
			const updateOpts = opts || {};

			window.imageBuddy.update(updateOpts);
		});

		/**
		 * ObjectFitImages
		 * only act upon images that have a valid src attribute
		 */
		objectFitImages('img:not([src^="data:"])');

		// Setup anchor scrolling
		$('a[href^="#"]').scrollToAnchor();

		/**
		 * Component - accordion
		 */
		$('.ui__accordion-container').each(function () {
			instances.components.accordion.push(new Accordion($(this)));
		});

		/**
		 * Component - tabbed content
		 */
		$('.ui__tab-container').each(function () {
			instances.components.tabbedContent.push(new TabbedContent($(this)));
		});

		/**
		 * Blocks - init and dynamically load Swiper
		 */
		const $sliderBlocks = $('.block-slider');
		const $testimonialBlocks = $('.block-testimonials');
		const $timelineSliderBlocks = $('.timeline-block-slider');
		const $timelineTripLogsBlocks = $('.timeline-block-trip-logs');
		const $tripLogSessionArchiveTemplate = $('.archive-trip-log-session').first();

		if (
			$sliderBlocks.length ||
			$testimonialBlocks.length ||
			$timelineSliderBlocks.length ||
			$timelineTripLogsBlocks.length ||
			$tripLogSessionArchiveTemplate.length
		) {
			import(/* webpackChunkName: "swiper" */ 'swiper')
				.then((Swiper) => {
					$sliderBlocks.each(function () {
						instances.blocks.slider.push(new BlockSlider($(this), Swiper.default));
					});

					$testimonialBlocks.each(function () {
						instances.blocks.testimonials.push(
							new BlockTestimonials($(this), Swiper.default)
						);
					});

					$timelineSliderBlocks.each(function () {
						instances.blocks.timelineSlider.push(
							new BlockTimelineSlider($(this), Swiper.default)
						);
					});

					$timelineTripLogsBlocks.each(function () {
						instances.blocks.timelineTripLogs.push(
							new BlockTimelineTripLogs($(this), Swiper.default)
						);
					});

					if ($tripLogSessionArchiveTemplate.length) {
						instances.templates.tripLogSessionArchive =
							new TripLogSessionArchiveTemplate(
								$tripLogSessionArchiveTemplate,
								Swiper.default
							);
					}
				})
				.catch((err) => {
					console.error(err);
					console.log('Swiper dynamic import failed');
				});
		}

		$('.block-instagram').each((i, el) => {
			instances.blocks.instagram.push(new BlockInstagram($(el)));
		});

		$('.timeline-block-content').each((i, el) => {
			instances.blocks.timelineContent.push(new BlockTimelineContent($(el)));
		});

		$('.timeline-block-hero').each((i, el) => {
			instances.blocks.timelineHero.push(new BlockTimelineHero($(el)));
		});

		/**
		 * Template - adventures archive
		 */
		const $adventuresArchiveTemplate = $('.post-type-archive-adventures').first();

		if ($adventuresArchiveTemplate.length) {
			import(
				/* webpackChunkName: "adventuresArchiveTemplate" */ './templates/adventures-archive'
			)
				.then((module) => {
					const AdventuresArchiveTemplate = module.default;
					instances.templates.adventuresArchive = new AdventuresArchiveTemplate(
						$adventuresArchiveTemplate
					);
				})
				.catch((err) => {
					console.error(err);
					console.log('AdventuresArchiveTemplate dynamic import failed');
				});
		}

		/**
		 * Template - trip logs archive
		 */
		const $tripLogsArchiveTemplate = $('.post-type-archive-trip-logs').first();

		if ($tripLogsArchiveTemplate.length) {
			instances.templates.tripLogsArchive = new TripLogsArchiveTemplate(
				$tripLogsArchiveTemplate
			);
		}

		/**
		 * Template - trip log session archive
		 */

		/**
		 * Modals - setup
		 */
		Modal.setDefaults({
			contentRemoveDelay: 250
		});

		/**
		 * Modals - check for page modal
		 */
		if (window.modalMessage) {
			const modalKey = `modal_message_seen_${window.modalMessage.hash}`;
			const modalSeen = Boolean(localStorage.getItem(modalKey)) || false;

			if (window.modalMessage.showOnce && modalSeen) {
				return;
			}

			Modal.show({
				content: window.modalMessage.content,
				containerClass: 'modal__text-container',
				onClose: () => {
					localStorage.setItem(modalKey, '1');
				}
			});
		}

		/**
		 * Modals - video (using custom modal)
		 */
		$('.colorbox--video').click((e) => {
			const videoSrc = $(e.currentTarget).attr('href');
			let videoUrl = videoSrc;

			e.preventDefault();

			const videoId = new RegExp('[\\?&]v=([^&#]*)').exec(videoSrc);

			if (videoId && videoId[1]) {
				videoUrl = `https://youtube.com/embed/${videoId[1]}?rel=0&wmode=transparent&autoplay=1&showinfo=0`;
			} else if (videoSrc.indexOf('vimeo.com') !== -1) {
				const urlTest = document.createElement('a');
				urlTest.href = videoSrc;

				if (urlTest.search.indexOf('autoplay') === -1) {
					videoUrl = urlTest.search.length
						? urlTest.href + '&autoplay=1'
						: urlTest.href + '?autoplay=1';
				}
			}

			Modal.show({
				content: `<iframe src="${videoUrl}" frameborder="0" allowfullscreen allow="autoplay"></iframe>`,
				containerClass: 'modal__video-container'
			});
		});

		/**
		 * Modals - text (using custom modal)
		 */
		$('.colorbox--text').click((e) => {
			const content = $(e.currentTarget).attr('data-modal-content');

			e.preventDefault();

			Modal.show({
				content: content,
				containerClass: 'modal__text-container'
			});
		});

		/**
		 * Modals - images (using colorbox)
		 */
		const $colorboxImageLinks = $('.colorbox--image');

		if ($colorboxImageLinks.length) {
			import(/* webpackChunkName: "jquery-colorbox" */ 'jquery-colorbox')
				.then((module) => {
					const initColorboxForImages = () => {
						const winWidth = $(window).width();
						const winHeight = $(window).height();

						const imageWidth = winWidth < 1024 ? winWidth - 100 : winWidth / 1.35;
						const imageHeight = winHeight - 100;

						$('.colorbox--image').each(function () {
							$(this).colorbox({
								maxWidth: imageWidth,
								maxHeight: imageHeight,
								transition: 'none',
								close: '',
								next: '',
								previous: '',
								rel: $(this).attr('data-image-group-ref'),
								onLoad: function () {
									$('#cboxNext').addClass('swiper-button-next');
									$('#cboxPrevious').addClass('swiper-button-prev');
								}
							});
						});
					};

					initColorboxForImages();

					$(window).resize(() => {
						initColorboxForImages();
					});
				})
				.catch((err) => {
					console.error(err);
					console.log('jquery-colorbox dynamic import failed');
				});
		}

		// initialize gravitate popups/hellobar handlers
		instances.gravPopups = new GravPopups();

		// Fix Safari 9/10 flexbox child height issues
		if ($('html').hasClass('browser-safari-9') || $('html').hasClass('browser-safari-10')) {
			$('.safari__flexbox-height-fix').each(function () {
				const parentHeight = $(this).parent().height();

				$(this).height(parentHeight);
			});
		}

		// Check for banner video and remove the element if there is a playback error
		// so the image underneath will be shown instead of a blank white video element
		const $bannerCoverVideo = $('.banner__cover-video');

		if ($bannerCoverVideo.length) {
			instances.components.bannerVideo = new BannerVideo($bannerCoverVideo);
		}

		// fix for gravity forms select container widths
		$('.ginput_container_select select').each(function () {
			if ($(this).hasClass('small')) {
				$(this).parents('.ginput_container_select').first().css('width', '24%');
			}

			if ($(this).hasClass('medium')) {
				$(this).parents('.ginput_container_select').first().css('width', '49%');
			}
		});

		// check URL hash to see if it should trigger an accordion item open event
		if (window.location.hash) {
			const $el = $(window.location.hash);

			if ($el.parents('.ui__accordion-container').length) {
				$el.trigger('open-accordion-item');
			}
		}

		// redirect if a select option specifies a URL
		$('.js__select-option-redirect').change(function () {
			var url = $(this).val().trim();

			if (url) {
				window.open(url, '_self');
			}
		});
	});

	/**
	 * Window scroll handler
	 */
	$(window).scroll(function () {
		gravUtil.setScrollVars();
		gravUtil.updateScrollClasses(headerHeight);
	});

	/**
	 * Window resize handler
	 */
	$(window).resize(function () {
		headerHeight = $('.site-header').height();
	});
});
